var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.1016,
    cy: 18.6343,
    r: 18,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1723_2481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1016 2.63501C9.26593 2.63501 2.10156 9.79797 2.10156 18.6343C2.10156 27.4706 9.26523 34.6336 18.1016 34.6336C26.9386 34.6336 34.1016 27.4706 34.1016 18.6343C34.1016 9.79797 26.9386 2.63501 18.1016 2.63501ZM18.1016 7.41899C21.0252 7.41899 23.3944 9.78884 23.3944 12.7111C23.3944 15.634 21.0252 18.0032 18.1016 18.0032C15.1793 18.0032 12.8102 15.634 12.8102 12.7111C12.8102 9.78884 15.1793 7.41899 18.1016 7.41899ZM18.098 30.4505C15.1821 30.4505 12.5115 29.3886 10.4516 27.6309C9.94976 27.2029 9.6602 26.5753 9.6602 25.9167C9.6602 22.953 12.0589 20.5811 15.0233 20.5811H21.1812C24.1464 20.5811 26.5359 22.953 26.5359 25.9167C26.5359 26.576 26.2477 27.2022 25.7452 27.6302C23.686 29.3886 21.0147 30.4505 18.098 30.4505Z",
    fill: "#F66524"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1723_2481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(2.10156 2.63428)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/IconUser.481220e6373f61ae1b0a965694da09f6.svg";
export { ForwardRef as ReactComponent };